/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import { BrowserDetection } from "@nuskin/ns-util";
import template from "./ns-recognition.html";
import "../ns-masonry/ns-masonry.js";
import "../ns-search/ns-search.js";

export class NsRecognition extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
    document.body.style.height = "auto";
    // hide header on mobile because it's in an app with it's own nav header
    if (BrowserDetection.isMobile()) {
      document.getElementById("header").style.display = "none";
      document.getElementById("content").style.cssText =
        "margin-top: 0 !important; padding-top: 0;";
    }
  }

  static get is() {
    return "ns-recognition";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      profileList: Array,
      filterArray: Array,
      searchText: String,
      selectText: String,
      localText: String,
      nativeText: String,
      host: {
        type: String,
        value: "https://devgw.mynuskin.com/mec/solr"
      },
      clientid: String,
      clientsecret: String,
      countryCodeTranslationMap: {
        type: Array,
        value: []
      },
      pagination: {
        type: Number,
        notify: true,
        value: 0
      },
      currentlySearching: {
        type: String,
        notify: true,
        value: "false"
      },
      gotAllData: {
        type: Boolean,
        notify: true,
        value: false
      },
      badgeColorMap: {
        type: Array,
        value: []
      },
      badgeTranslationMap: {
        type: Array,
        value: []
      }
    };
  }
}

customElements.define(NsRecognition.is, NsRecognition);
